import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-homepage-agent',
  templateUrl: './homepage-agent.component.html',
  styleUrls: ['./homepage-agent.component.scss'],
})
export class HomepageAgentComponent implements OnInit {
  environment = environment;
  constructor() {}
  ngOnInit(): void {}
  panelOpenState = false;
}
